import React, { useState } from 'react';
import { Text } from 'components/Text';
import { Button } from 'components/Button';

type DenyReturnProps = {
  handleDeny?: (input: { reason: string; description: string }) => void;
  loading?: boolean;
};

export const DenyReturn = ({ handleDeny, loading }: DenyReturnProps) => {
  const [input, setInput] = useState({
    reason: '',
    description: '',
  });

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
    field: string,
  ) => {
    const { value } = e.target;
    setInput({ ...input, [field]: value });
  };

  const reasons = [
    'Item condition is not as described',
    'Return window has expired',
    'Item is not eligible for return',
    'Missing original packaging',
    'Other',
  ];

  return (
    <div className="block mt-4 w-full">
      <div className="border rounded p-5 bg-white">
        <div className="flex justify-between px-3 py-2 bg-gray-50 rounded-md">
          <Text value="Deny return request" type="bold" />
        </div>

        <div className="mt-6">
          <label className="block text-sm font-medium text-gray-700">
            Reason
          </label>
          <select
            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
            value={input.reason}
            onChange={(e) => handleChange(e, 'reason')}
          >
            <option value="">Select a reason</option>
            {reasons.map((r) => (
              <option key={r} value={r}>
                {r}
              </option>
            ))}
          </select>

          <label className="block text-sm font-medium text-gray-700 mt-4">
            Description
          </label>
          <textarea
            rows={4}
            className="border border-1 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 w-full sm:text-sm border-gray-300 rounded-md mt-1 p-2"
            placeholder="Explain the reason for denial..."
            value={input.description}
            onChange={(e) => handleChange(e, 'description')}
          />

          <Text
            type="sm"
            value={
              'Note: The reason and description will be visible to the customer.'
            }
            className="text-gray-400 mt-2"
          />
        </div>

        <div className="mt-6">
          <Button
            onClick={() => handleDeny && handleDeny(input)}
            isLoading={loading}
            className="w-full"
            color="danger"
            disabled={!input.reason}
          >
            Confirm Denial
          </Button>
        </div>
      </div>
    </div>
  );
};
